<template>
    <div class="flex min-h-screen bg-base text-white font-sans">
    <Sidebar />
  <div class="flex-1 flex flex-col mt-20 md:-mt-0 p-4">

    <!-- HEADER -->
    <div
      class=" my-4 rounded-2xl bg-gradient-to-b from-[#1a2220]/90 to-[#12181b]/90 ring-1 ring-[#334D44]/60 backdrop-blur-xl shadow-xl p-4 flex items-center justify-between">

      <div>
        <h1
          class=" font-extrabold tracking-tight bg-gradient-to-r from-[#b9f1cf] to-white bg-clip-text text-transparent">
          مدیریت تراکنش‌های کیف‌پول
        </h1>
       
      </div>

      <div class="flex items-center gap-4 flex-wrap">

        <!-- SEARCH FIELD -->
        <div class="relative">
          <input
            v-model="search"
            placeholder="جستجو..."
            class="w-72 bg-white/10 backdrop-blur-xl px-12 py-3 rounded-2xl text-sm
                   border border-white/10 shadow-inner outline-none
                   focus:ring-2 focus:ring-[#b9f1cf] transition placeholder:text-white/40"
          />
          <svg class="absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 text-white/50"
               fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"
              d="m21 21-4.35-4.35M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z"/>
          </svg>
        </div>

        <!-- FILTER -->
        <select
          v-model="statusFilter"
          class="bg-white/10 px-4 py-3 rounded-2xl text-sm border border-white/10
                 focus:border-[#b9f1cf] focus:ring-[#b9f1cf] outline-none transition">
          <option value="all">همه</option>
          <option value="pending">در انتظار</option>
          <option value="approved">تایید شده</option>
          <option value="rejected">رد شده</option>
        </select>

      </div>
    </div>

    <!-- MAIN SECTION -->
    <div
      class="rounded-2xl bg-gradient-to-b from-[#1a2220]/90 to-[#12181b]/90 ring-1 ring-[#334D44]/60 backdrop-blur-xl shadow-xl p-4">

      <!-- LOADING -->
      <div v-if="loading" class="space-y-4">
        <div v-for="n in 6" :key="n"
             class="h-14 bg-white/10 rounded-2xl animate-pulse"></div>
      </div>

      <!-- EMPTY -->
      <div v-else-if="filtered.length === 0"
           class="text-center p-20 text-white/40 text-sm">
        هیچ سفارشی پیدا نشد.
      </div>

      <!-- DESKTOP TABLE -->
      <div v-else class="hidden md:block overflow-x-auto">
        <table
          class="min-w-full text-right rounded-2xl overflow-hidden
                 bg-white/5 backdrop-blur-md border border-white/10">

          <thead class="bg-white/10 border-b border-white/10">
            <tr class="text-xs uppercase text-white/60">
              <th class="px-4 py-4 text-sm font-semibold">#</th>
              <th class="px-4 py-4 text-sm font-semibold">کاربر</th>
              <th class="px-4 py-4 text-sm font-semibold">آیتم</th>
              <th class="px-4 py-4 text-sm font-semibold">مبلغ</th>
              <th class="px-4 py-4 text-sm font-semibold">نوع</th>
              <th class="px-4 py-4 text-sm font-semibold">وضعیت</th>
              <th class="px-4 py-4 text-sm font-semibold">تاریخ</th>
              <th class="px-4 py-4 text-sm font-semibold">عملیات</th>
            </tr>
          </thead>

          <tbody class="divide-y divide-white/10">
            <tr
              v-for="(item) in paginated"
              :key="item._id"
              class="transition-all duration-200 hover:bg-white/10 hover:shadow-[0_0_20px_#b9f1cf55]">

              <td class="px-4 py-4 text-sm text-white/80">{{ item.uid }}</td>
              <td class="px-4 py-4 text-sm text-white/80">{{ item.userid?.phone }}</td>
              <td class="px-4 py-4 text-sm text-white/80">{{ item.item }}</td>
              <td class="px-4 py-4 text-sm text-white/80">{{ formatMoney(item.amount) }}</td>

              <td class="px-4 py-4 text-sm font-semibold"
                  :class="item.type==='buy' ? 'text-emerald-300' : 'text-rose-300'">
                {{ item.type === 'buy' ? 'خرید' : 'فروش' }}
              </td>

              <td class="px-4 py-4">
                <span
                  v-if="item.isApproved"
                  class="px-3 py-1 text-xs rounded-xl bg-emerald-500/15 text-emerald-300 border border-emerald-400/40">
                  تایید شده
                </span>

                <span
                  v-else-if="item.rejected"
                  class="px-3 py-1 text-xs rounded-xl bg-rose-500/15 text-rose-300 border border-rose-400/40">
                  رد شده
                </span>

                <span
                  v-else
                  class="px-3 py-1 text-xs rounded-xl bg-yellow-500/15 text-yellow-300 border border-yellow-400/40">
                  در انتظار
                </span>
              </td>

              <td class="px-4 py-4 text-xs text-white/50">{{ formatDate(item.createdAt) }}</td>

              <td class="px-4 py-4 flex items-center gap-2">

                <!-- DETAILS BUTTON -->
                <button
                  @click="openModal(item)"
                  class="px-4 py-2 rounded-xl bg-white/10 backdrop-blur-xl border border-white/10 
                         text-sm hover:bg-white/20 transition shadow-[0_0_15px_#b9f1cf33]">
                  جزئیات
                </button>

                <!-- APPROVE -->
                <button
                  v-if="!item.isApproved && !item.rejected"
                  @click="approve(item._id)"
                  class="px-4 py-2 rounded-xl bg-emerald-500/20 text-emerald-300 border border-emerald-400/30 
                         text-sm hover:bg-emerald-500/30 transition">
                  تایید
                </button>

                <!-- REJECT -->
                <button
                  v-if="!item.isApproved && !item.rejected"
                  @click="rejectOrder(item._id)"
                  class="px-4 py-2 rounded-xl bg-rose-500/20 text-rose-300 border border-rose-400/30 
                         text-sm hover:bg-rose-500/30 transition">
                  رد
                </button>

              </td>
            </tr>
          </tbody>

        </table>
      </div>

      <!-- MOBILE LIST -->
      <div v-if="filtered.length" class="md:hidden grid gap-5 mt-6">

        <div
          v-for="(item,index) in paginated"
          :key="item._id"
          class="p-5 rounded-3xl bg-white/10 backdrop-blur-xl border border-white/10 shadow-xl">

          <div class="flex justify-between items-center mb-3">
            <span class="text-white/40 text-xs">{{ indexStart + index }}</span>

            <span
              :class="item.type==='deposit'
                ? 'px-3 py-1 text-xs rounded-xl bg-emerald-500/15 text-emerald-300 border border-emerald-400/40'
                : 'px-3 py-1 text-xs rounded-xl bg-rose-500/15 text-rose-300 border border-rose-400/40'">
              {{ item.type==='deposit'?'واریز':'برداشت' }}
            </span>
          </div>

          <div class="grid grid-cols-2 gap-3 text-sm">
            <span class="text-white/50">کاربر</span>
            <span>{{ item.userid?.phone }}</span>

            <span class="text-white/50">آیتم</span>
            <span>{{ item.item }}</span>

            <span class="text-white/50">مبلغ</span>
            <span>{{ formatMoney(item.amount) }}</span>

            <span class="text-white/50">وضعیت</span>
            <span>
              <span v-if="item.isApproved" class="text-emerald-300">تایید شده</span>
              <span v-else-if="item.rejected" class="text-rose-300">رد شده</span>
              <span v-else class="text-yellow-300">در انتظار</span>
            </span>
          </div>

          <p class="mt-3 text-xs text-white/40">{{ formatDate(item.createdAt) }}</p>

          <div class="flex gap-3 mt-4">

            <button
              @click="openModal(item)"
              class="px-4 py-2 rounded-xl bg-white/10 backdrop-blur-xl border border-white/10 
                     text-sm hover:bg-white/20 transition shadow-[0_0_15px_#b9f1cf33] flex-1">
              مشاهده
            </button>

            <button
              v-if="!item.isApproved && !item.rejected"
              @click="approve(item._id)"
              class="px-4 py-2 rounded-xl bg-emerald-500/20 text-emerald-300 border border-emerald-400/30 
                     text-sm hover:bg-emerald-500/30 transition flex-1">
              تایید
            </button>

            <button
              v-if="!item.isApproved && !item.rejected"
              @click="rejectOrder(item._id)"
              class="px-4 py-2 rounded-xl bg-rose-500/20 text-rose-300 border border-rose-400/30 
                     text-sm hover:bg-rose-500/30 transition flex-1">
              رد
            </button>

          </div>

        </div>

      </div>

      <!-- PAGINATION -->
      <div v-if="filtered.length"
           class="flex justify-between items-center mt-10 text-xs text-white/50">

        <span>صفحه {{ page }} از {{ totalPages }}</span>

        <div class="flex gap-2">
          <button
            @click="page--"
            :disabled="page===1"
            class="px-3 py-2 rounded-xl bg-white/10 border border-white/10 
                   disabled:opacity-30 hover:bg-white/20 transition">
            ‹
          </button>

          <button
            @click="page++"
            :disabled="page===totalPages"
            class="px-3 py-2 rounded-xl bg-white/10 border border-white/10 
                   disabled:opacity-30 hover:bg-white/20 transition">
            ›
          </button>
        </div>

      </div>

    </div>

    <!-- MODAL -->
    <div v-if="modal"
         class="fixed inset-0 bg-black/70 backdrop-blur-xl flex items-center justify-center p-4">

      <div
        class="w-full max-w-md rounded-3xl bg-white/10 border border-white/10 backdrop-blur-2xl
               shadow-[0_20px_60px_rgb(0,0,0,0.6)] p-6">

        <h3 class="text-xl font-bold mb-4">جزئیات تراکنش</h3>

        <div class="space-y-3 text-sm">
          <p><b>کاربر:</b> {{ modal.userid?.phone }}</p>
          <p><b>آیتم:</b> {{ modal.item }}</p>
          <p><b>مبلغ:</b> {{ formatMoney(modal.amount) }}</p>
          <p><b>نوع:</b> {{ modal.type==='deposit'?'واریز':'برداشت' }}</p>
          <p><b>تاریخ:</b> {{ formatDate(modal.createdAt) }}</p>
        </div>

        <div class="flex gap-3 mt-6">

          <button
            class="px-4 py-2 rounded-xl bg-white/10 backdrop-blur-xl border border-white/10 
                   text-sm hover:bg-white/20 transition shadow-[0_0_15px_#b9f1cf33] flex-1"
            @click="modal=null">
            بستن
          </button>

          <button
            v-if="!modal.isApproved && !modal.rejected"
            @click="approve(modal._id)"
            class="px-4 py-2 rounded-xl bg-emerald-500/20 text-emerald-300 border border-emerald-400/30 
                   text-sm hover:bg-emerald-500/30 transition flex-1">
            تایید
          </button>

          <button
            v-if="!modal.isApproved && !modal.rejected"
            @click="rejectOrder(modal._id)"
            class="px-4 py-2 rounded-xl bg-rose-500/20 text-rose-300 border border-rose-400/30 
                   text-sm hover:bg-rose-500/30 transition flex-1">
            رد
          </button>

        </div>

      </div>

    </div>

  </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue"
import axios from "axios"
import Sidebar from '@/components/admin/SidebarAdmin.vue'
import Swal from "sweetalert2"

const url = process.env.VUE_APP_API_URL

const data = ref([])
const search = ref("")
const statusFilter = ref("all")
const modal = ref(null)
const loading = ref(true)
const page = ref(1)
const perPage = 10

onMounted(async () => {
  try {
    const res = await axios.get(`${url}/admin/wallet/order`)
    data.value = res.data.data || []
  } catch (e) {
    Swal.fire({
      icon: "error",
      title: "خطا!",
      text: e.response?.data?.error || "خطا در دریافت سفارشات",
      confirmButtonColor: "#b9f1cf",
    })
  }
  loading.value = false
})

const filtered = computed(() => {
  const q = search.value.trim()

  return data.value.filter((i) => {
    const matchSearch =
      !q ||
      i.item?.includes(q) ||
      String(i.amount).includes(q) ||
      String(i.userid?.phone).includes(q)

    const matchStatus =
      statusFilter.value === "all" ||
      (statusFilter.value === "pending" && !i.isApproved && !i.rejected) ||
      (statusFilter.value === "approved" && i.isApproved) ||
      (statusFilter.value === "rejected" && i.rejected)

    return matchSearch && matchStatus
  })
})

const totalPages = computed(() =>
  Math.max(1, Math.ceil(filtered.value.length / perPage))
)

const paginated = computed(() => {
  const start = (page.value - 1) * perPage
  return filtered.value.slice(start, start + perPage)
})

const indexStart = computed(() => (page.value - 1) * perPage + 1)

function formatMoney(n) {
  return new Intl.NumberFormat("fa-IR").format(n)
}

function formatDate(date) {
  return new Date(date).toLocaleString("fa-IR")
}

function openModal(item) {
  modal.value = item
}

async function approve(id) {
  try {
    await axios.put(`${url}/admin/wallet/order/approve/${id}`)

    const target = data.value.find((x) => x._id === id)
    if (target) target.isApproved = true

    Swal.fire({
      icon: "success",
      title: "تایید انجام شد",
      text: "سفارش با موفقیت تایید شد",
      confirmButtonColor: "#b9f1cf",
    })
  } catch (e) {
    Swal.fire({
      icon: "error",
      title: "خطا در تایید",
      text: e.response?.data?.error || "مشکلی در تایید پیش آمد",
      confirmButtonColor: "#b9f1cf",
    })
  }
}

async function rejectOrder(id) {
  try {
    await axios.put(`${url}/admin/wallet/order/reject/${id}`)

    const target = data.value.find((x) => x._id === id)
    if (target) target.rejected = true

    Swal.fire({
      icon: "success",
      title: "رد انجام شد",
      text: "سفارش با موفقیت رد شد",
      confirmButtonColor: "#b9f1cf",
    })
  } catch (e) {
    Swal.fire({
      icon: "error",
      title: "خطا در رد سفارش",
      text: e.response?.data?.error || "مشکلی در رد سفارش پیش آمد",
      confirmButtonColor: "#b9f1cf",
    })
  }
}
</script>
